import React, { useState, useRef, useEffect } from 'react';
import { Button, Card, Form, InputGroup } from 'react-bootstrap';
import { X, ChevronLeft, Send, Paperclip, Whatsapp } from 'react-bootstrap-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import '../sources/styles/stylesChatbot.css';
import Cookies from 'universal-cookie';
import axios from 'axios';
import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const DIAS_PARA_RESETEAR = 7;

const AVATAR_URLS = {
    launcher: "https://recursos.soferco.tech/estaticas/milo-boton.webp",
    profile: "https://recursos.soferco.tech/estaticas/milo-perfil.webp",
    welcome: "https://recursos.soferco.tech/estaticas/milo-bienvenida.webp",
    thinking: "https://recursos.soferco.tech/estaticas/milo-pensando.webp"
};
const Chatbot = () => {
    const navigate = useNavigate();
    const [estaAbierto, setEstaAbierto] = useState(false);
    const [estaCerrando, setEstaCerrando] = useState(false);
    const [flujoChat, setFlujoChat] = useState(null);
    const [historial, setHistorial] = useState([]);
    const [idSesionChat, setIdSesionChat] = useState(null);
    const [cargandoFlujo, setCargandoFlujo] = useState(true);
    const [modoAyuda, setModoAyuda] = useState(false);
    const [mensajeUsuario, setMensajeUsuario] = useState('');
    const [pasoData, setPasoData] = useState('');
    const [datosUsuario, setDatosUsuario] = useState({
        nombre: '',
        email: '',
        telefono: '',
        mensaje: ''
    });
    const [archivoAdjunto, setArchivoAdjunto] = useState(null);
    const [nombreArchivo, setNombreArchivo] = useState('');
    const [botEscribiendo, setBotEscribiendo] = useState(false);
    const [imagenWhatsapp, setImagenWhatsapp] = useState([]);
    const [mostrarOpciones, setMostrarOpciones] = useState(false);

    const refFinMensajes = useRef(null);
    const refInput = useRef(null);
    const refArchivo = useRef(null);
    const cookies = new Cookies();
    const location = useLocation();

    useEffect(() => {
        cargarFlujoChat();
    }, []);

    useEffect(() => {
        if (flujoChat) {
            cargarhistorial_chat();
        }
        // eslint-disable-next-line
    }, [flujoChat]);

    useEffect(() => {
        if (historial.length > 1) {
            guardarhistorial_chat();
        }
        // eslint-disable-next-line
    }, [historial]);

    useEffect(() => {
        if (modoAyuda && refInput.current) {
            refInput.current.focus();
        }
    }, [modoAyuda, pasoData]);

    useEffect(() => {
        const accessToken = cookies.get('accesToken');
        const bannerIncicio = async () => {
            const urlBanner = process.env.REACT_APP_SERVER + '/api/v1/products/banner';
            const [dataBannerW] = await Promise.all([
                axios.post(urlBanner, { pagina: 'whatsapp' }, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`,
                    },
                }),
            ]);
            setImagenWhatsapp(dataBannerW.data);
        }
        bannerIncicio();
        // eslint-disable-next-line
    }, []);

    const cargarFlujoChat = async () => {
        try {
            const url = `${process.env.REACT_APP_SERVER}/api/v1/chatbot/flow`;
            const { data } = await axios.get(url);
            if (data.success && data.chatFlow) {
                setFlujoChat(data.chatFlow);
                if (data.chatFlow.start) {
                    setHistorial([{
                        step: 'start',
                        type: 'bot',
                        ...data.chatFlow.start,
                        timestamp: moment().toISOString(),
                        heroImage: 'welcome'
                    }]);
                }
            }
        } catch (error) {
            console.error('Error cargando flujo del chat:', error);
            const flujoDefecto = {
                start: {
                    message: "¡Hola! 👋 Estamos aquí para ayudarte. ¿Qué necesitas hoy?",
                    options: [
                        { label: "Ayuda", next: "ayuda" }
                    ]
                },
                ayuda: {
                    message: "Por favor, contacta con soporte técnico.",
                    options: [
                        { label: "Volver al inicio", next: "start" }
                    ]
                }
            };
            setFlujoChat(flujoDefecto);
            setHistorial([{
                step: 'start',
                type: 'bot',
                ...flujoDefecto.start,
                timestamp: moment().toISOString(),
                heroImage: 'welcome'
            }]);
        } finally {
            setCargandoFlujo(false);
        }
    };

    const enviarSolicitudSoporte = async (tipoSolicitud = 'ayuda_general', datosEnviar = null) => {
        try {
            const identificadorUsuario = obtenerIdentificadorUsuario();
            if (!identificadorUsuario) return;
            const usuario = cookies.get('user');
            const tokenAcceso = cookies.get('accesToken');
            const url = `${process.env.REACT_APP_SERVER}/api/v1/chatbot/support-request`;
            const datos = datosEnviar || datosUsuario;
            const formData = new FormData();
            formData.append('id_sesion', idSesionChat || '');
            formData.append('tipo_usuario', identificadorUsuario.type);
            formData.append('id_usuario', identificadorUsuario.id);
            formData.append('nombre_usuario', datos.nombre || usuario?.nombre || '');
            formData.append('email_usuario', datos.email || usuario?.email || '');
            formData.append('telefono_usuario', datos.telefono || usuario?.telefono || '');
            formData.append('mensaje_usuario', datos.mensaje || '');
            formData.append('historial_chat', JSON.stringify([...historial, { type: 'user', message: datos.mensaje }]));
            formData.append('tipo_solicitud', tipoSolicitud);
            if (archivoAdjunto) {
                formData.append('archivo', archivoAdjunto);
            }
            await axios.post(url, formData, {
                headers: {
                    "Authorization": `Bearer ${tokenAcceso}`,
                    "Content-Type": "multipart/form-data"
                }
            });
            console.log('Solicitud de soporte enviada correctamente');
            setArchivoAdjunto(null);
            setNombreArchivo('');
            if (refArchivo.current) {
                refArchivo.current.value = '';
            }
        } catch (error) {
            console.error('Error enviando solicitud de soporte:', error);
        }
    };

    const obtenerIdentificadorUsuario = () => {
        const usuario = cookies.get('user');
        if (usuario && usuario.id_cliente) {
            return { type: 'cliente', id: usuario.id_cliente };
        } else if (usuario && usuario.ip) {
            return { type: 'ip', id: usuario.ip };
        }
        return null;
    };

    const renderizarMensaje = (mensaje) => {
        return mensaje.split('\n').map((linea, indice) => (
            <React.Fragment key={indice}>
                {linea}
                {indice < mensaje.split('\n').length - 1 && <br />}
            </React.Fragment>
        ));
    };

    const formatearTimestamp = (timestamp) => {
        const fechaMensaje = moment(timestamp);
        const esHoy = moment().isSame(fechaMensaje, 'day');
        if (esHoy) {
            return `Hoy ${fechaMensaje.format('HH:mm')}`;
        } else {
            return fechaMensaje.format('DD/MM/YYYY HH:mm');
        }
    };

    const agregarMensajeBot = (mensaje, opciones = null, delay = 800, heroImage = null) => {
        return new Promise((resolve) => {
            setBotEscribiendo(true);
            setTimeout(() => {
                setBotEscribiendo(false);
                const nuevoMensaje = {
                    type: 'bot',
                    message: mensaje,
                    timestamp: moment().toISOString()
                };
                if (opciones) {
                    nuevoMensaje.options = opciones;
                }
                if (heroImage) {
                    nuevoMensaje.heroImage = heroImage;
                }
                setHistorial(prev => [...prev, nuevoMensaje]);
                resolve();
            }, delay);
        });
    };

    const agregarMensajeUsuario = (mensaje) => {
        setHistorial(prev => [...prev, {
            type: 'user',
            message: mensaje,
            timestamp: moment().toISOString()
        }]);
    };

    const cargarhistorial_chat = async () => {
        try {
            const identificadorUsuario = obtenerIdentificadorUsuario();
            if (!identificadorUsuario) {
                return;
            }
            const tokenAcceso = cookies.get('accesToken');
            const url = `${process.env.REACT_APP_SERVER}/api/v1/chatbot/history`;
            const { data } = await axios.post(url, {
                tipo_usuario: identificadorUsuario.type,
                id_usuario: identificadorUsuario.id
            }, {
                headers: { "Authorization": `Bearer ${tokenAcceso}` }
            });
            if (data.success) {
                if (data.chatSession) {
                    const diasDesdeUltimaActualizacion = Math.floor(
                        (new Date() - new Date(data.chatSession.fecha_actualizacion)) / (1000 * 60 * 60 * 24)
                    );
                    if (diasDesdeUltimaActualizacion < DIAS_PARA_RESETEAR && data.chatSession.historial) {
                        try {
                            const historialGuardado = JSON.parse(data.chatSession.historial);
                            if (Array.isArray(historialGuardado) && historialGuardado.length > 0) {
                                setHistorial(historialGuardado);
                            }
                        } catch (e) {
                            console.error('Error parseando historial del chat:', e);
                        }
                    }
                    setIdSesionChat(data.chatSession.id);
                }
            }
        } catch (error) {
            console.error('Error cargando historial del chat:', error);
        }
    };

    const guardarhistorial_chat = async () => {
        try {
            const identificadorUsuario = obtenerIdentificadorUsuario();
            if (!identificadorUsuario) return;
            if (historial.length <= 1) return;
            const tokenAcceso = cookies.get('accesToken');
            const url = `${process.env.REACT_APP_SERVER}/api/v1/chatbot/save`;
            const { data } = await axios.post(url, {
                tipo_usuario: identificadorUsuario.type,
                id_usuario: identificadorUsuario.id,
                historial: JSON.stringify(historial),
                id_sesion: idSesionChat
            }, {
                headers: { "Authorization": `Bearer ${tokenAcceso}` }
            });
            if (data.success && data.id_sesion && !idSesionChat) {
                setIdSesionChat(data.id_sesion);
            }
        } catch (error) {
            console.error('Error guardando historial del chat:', error);
        }
    };

    const alternarChat = () => {
        if (estaAbierto) {
            setEstaCerrando(true);
            setTimeout(() => {
                setEstaAbierto(false);
                setEstaCerrando(false);
                if (historial.length === 0) {
                    resetearChat();
                }
            }, 300);
        } else {
            setMostrarOpciones(!mostrarOpciones);
        }
    };

    const resetearChat = () => {
        if (flujoChat && flujoChat.start) {
            setHistorial([{
                step: 'start',
                type: 'bot',
                ...flujoChat.start,
                timestamp: moment().toISOString(),
                heroImage: 'welcome'
            }]);
            setModoAyuda(false);
            setPasoData('');
            setDatosUsuario({ nombre: '', email: '', telefono: '', mensaje: '' });
            setArchivoAdjunto(null);
            setNombreArchivo('');
            if (refArchivo.current) {
                refArchivo.current.value = '';
            }
        }
    };

    /*const iniciarModoAyuda = async () => {
        const usuario = cookies.get('user');
        setHistorial(prev => [...prev, {
            type: 'user',
            message: 'Necesito ayuda',
            timestamp: moment().toISOString()
        }]);

        if (usuario && usuario.id_cliente && usuario.nombre && usuario.email) {
            setDatosUsuario({
                nombre: usuario.nombre,
                email: usuario.email,
                telefono: usuario.telefono || '',
                mensaje: ''
            });
            setPasoData('mensaje');
            setModoAyuda(true);
            await agregarMensajeBot(`Hola ${usuario.nombre}, ¿en qué podemos ayudarte? Por favor describe tu consulta:`);
        } else {
            setPasoData('nombre');
            setModoAyuda(true);
            await agregarMensajeBot('Claro, con gusto te ayudaremos. Para poder asistirte mejor, necesito algunos datos.\n\n¿Cuál es tu nombre?', null, 1000);
        }
    };*/

    const handleEntradaUsuario = async (e) => {
        e.preventDefault();
        if (!mensajeUsuario.trim() || botEscribiendo) return;
        const mensaje = mensajeUsuario.trim();
        setMensajeUsuario('');
        setHistorial(prev => [...prev, {
            type: 'user',
            message: mensaje,
            timestamp: moment().toISOString()
        }]);
        if (pasoData === 'nombre') {
            setDatosUsuario(prev => ({ ...prev, nombre: mensaje }));
            setPasoData('email');
            await agregarMensajeBot('Perfecto. ¿Cuál es tu correo electrónico?');
        } else if (pasoData === 'email') {
            const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!regexEmail.test(mensaje)) {
                await agregarMensajeBot('Por favor ingresa un correo electrónico válido.', null, 600);
                return;
            }
            setDatosUsuario(prev => ({ ...prev, email: mensaje }));
            setPasoData('telefono');
            await agregarMensajeBot('¿Cuál es tu número de teléfono?');
        } else if (pasoData === 'telefono') {
            setDatosUsuario(prev => ({ ...prev, telefono: mensaje }));
            setPasoData('mensaje');
            await agregarMensajeBot('Gracias. Ahora, por favor describe tu consulta o problema:');
        } else if (pasoData === 'mensaje') {
            const datosActualizados = { ...datosUsuario, mensaje: mensaje };
            setDatosUsuario(datosActualizados);
            enviarSolicitudSoporte('solicitud_ayuda', datosActualizados);
            setModoAyuda(false);
            setPasoData('');
            await agregarMensajeBot(
                '¡Gracias por contactarnos! 🎉\nHemos recibido tu solicitud y un miembro de nuestro equipo se pondrá en contacto contigo pronto.\n¿Hay algo más en lo que pueda ayudarte?',
                [
                    { label: 'Volver al inicio', next: 'start' },
                    { label: 'Cerrar chat', action: 'close' }
                ],
                1000,
                'welcome'
            );
        }
    };

    const handleDireccion = async (metodo, id, nombre) => {
        cookies.remove('menu');
        const menu = `${metodo}_${id}_${nombre}_1`;
        cookies.set('menu', menu, { path: '/' });
        if (location.pathname === "/catalogo") {
            window.location.reload();
        } else {
            navigate('/catalogo');
        }
    }

    const cargarGrandesLineas = async () => {
        try {
            const accessToken = cookies.get('accesToken');
            const [resGranLinea, resRelacion] = await Promise.all([
                axios.get(`${process.env.REACT_APP_SERVER}/api/v1/items/gran_linea`, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }),
                axios.get(`${process.env.REACT_APP_SERVER}/api/v1/items/gran_linea_relacion`, {
                    headers: { Authorization: `Bearer ${accessToken}` }
                })
            ]);
            const granLineas = resGranLinea.data[0];
            const relaciones = resRelacion.data[0];
            const estructura = granLineas.map(gl => {
                const relacionesGranLinea = relaciones.filter(
                    r => r.cod_granlinea === gl.cod_gran_linea
                );
                const lineas = [...new Map(
                    relacionesGranLinea.map(r => [
                        r.cod_linea,
                        {
                            cod_linea: r.cod_linea,
                            nombre_linea: r.descripcion_linea
                        }
                    ])
                ).values()];
                return {
                    cod_gran_linea: gl.cod_gran_linea,
                    nombre: gl.nombre,
                    lineas
                };
            });
            return estructura;
        } catch (error) {
            console.error('Error cargando grandes líneas', error);
        }
    };

    const mostrarGrandesLineas = async () => {
        const categorias = await cargarGrandesLineas();
        await agregarMensajeBot(
            'Perfecto 👌\nSelecciona una categoría:',
            categorias.map(gl => ({
                label: gl.nombre,
                action: 'seleccionar_gran_linea',
                data: gl
            }))
        );
    };

    const handleClickOpcion = async (opcion) => {
        if (opcion.next === 'buscar_por_categoria') {
            agregarMensajeUsuario(opcion.label);
            mostrarGrandesLineas();
            return;
        }
        if (opcion.action === 'seleccionar_gran_linea') {
            const granLinea = opcion.data;
            agregarMensajeUsuario(opcion.label);
            await agregarMensajeBot(
                `🧱 ${granLinea.nombre}\nAhora elige una línea:`,
                granLinea.lineas.map(linea => ({
                    label: linea.nombre_linea,
                    action: 'seleccionar_linea',
                    data: linea.cod_linea
                }))
            );
        }
        if (opcion.action === 'seleccionar_linea') {
            const cod_linea = opcion.data;
            agregarMensajeUsuario(opcion.label);
            await agregarMensajeBot(
                `🔎 Mostrando productos de **${opcion.label}**`,
                [
                    { label: '🔁 Buscar otra categoría', next: 'buscar_por_categoria' },
                    { label: '🏠 Volver al inicio', next: 'start' }
                ]
            );
            handleDireccion(
                'linea',
                cod_linea,
                opcion.label,
            );
        }

        if (opcion.action === 'link') {
            setHistorial(prev => [
                ...prev,
                {
                    type: 'user',
                    message: opcion.label,
                    timestamp: moment().toISOString()
                },
                {
                    step: 'fin_positivo',
                    type: 'bot',
                    ...flujoChat.fin_positivo,
                    timestamp: moment().toISOString()
                }
            ]);

            setEstaCerrando(true);
            setTimeout(() => {
                setEstaAbierto(false);
                setEstaCerrando(false);
                if (opcion.url.startsWith('http')) {
                    window.open(opcion.url, '_blank');
                } else if (opcion.url === 'whatsapp') {
                    window.open(`${imagenWhatsapp[0].telefono}`, '_blank');
                } else {
                    navigate(opcion.url);
                }
            }, 1000);
        } else if (opcion.action === 'close') {
            setEstaCerrando(true);
            setTimeout(() => {
                setEstaAbierto(false);
                setEstaCerrando(false);
            }, 300);
        } else if (opcion.next && flujoChat) {
            /*if (opcion.next === 'ayuda' || opcion.label.toLowerCase().includes('ayuda')) {
                iniciarModoAyuda();
                return;
            }*/
            const siguientePaso = flujoChat[opcion.next];
            if (siguientePaso) {
                setHistorial(prev => [
                    ...prev,
                    {
                        type: 'user',
                        message: opcion.label,
                        timestamp: moment().toISOString()
                    },
                    {
                        step: opcion.next,
                        type: 'bot',
                        ...siguientePaso,
                        timestamp: moment().toISOString()
                    }
                ]);
            }
        }
    };

    const handleAtras = () => {
        if (modoAyuda) {
            setModoAyuda(false);
            setPasoData('');
            setDatosUsuario({ nombre: '', email: '', telefono: '', mensaje: '' });
            setArchivoAdjunto(null);
            setNombreArchivo('');
            if (refArchivo.current) {
                refArchivo.current.value = '';
            }
            if (historial.length > 2) {
                setHistorial(prev => prev.slice(0, -2));
            }
        } else if (historial.length > 1) {
            setHistorial(prev => prev.slice(0, -1));
        }
    };

    const handleSeleccionarArchivo = (e) => {
        const archivo = e.target.files[0];
        if (archivo) {
            const maxSize = 20 * 1024 * 1024; // 20MB
            if (archivo.size > maxSize) {
                alert('El archivo es demasiado grande. El tamaño máximo permitido es 20MB.');
                e.target.value = '';
                return;
            }
            setArchivoAdjunto(archivo);
            setNombreArchivo(archivo.name);
        }
    };

    const handleEliminarArchivo = () => {
        setArchivoAdjunto(null);
        setNombreArchivo('');
        if (refArchivo.current) {
            refArchivo.current.value = '';
        }
    };

    const desplazarAlFinal = () => {
        refFinMensajes.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        desplazarAlFinal();
    }, [historial, estaAbierto]);

    if (cargandoFlujo) {
        return null;
    }

    return (
        <div className="chatbot-container">
            {!estaAbierto && !estaCerrando && (
                <>
                    {mostrarOpciones && (
                        <div className="chatbot-options">
                            {imagenWhatsapp.length > 0 && (
                                <a
                                    href={imagenWhatsapp[0].telefono}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="chatbot-option-btn whatsapp"
                                >
                                    <span className="chatbot-option-label">WhatsApp</span>
                                    <Whatsapp size={24} />
                                </a>
                            )}
                            <Button
                                className="chatbot-option-btn chat"
                                onClick={() => {
                                    setMostrarOpciones(false);
                                    setEstaAbierto(true);
                                }}
                            >
                                <span className="chatbot-option-label">Milo</span>
                                <img
                                    src={AVATAR_URLS.profile}
                                    alt="Chat"
                                    style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover' }}
                                />
                            </Button>
                        </div>
                    )}
                    <Button
                        className="chatbot-toggle-btn rounded-circle shadow p-0 overflow-hidden"
                        variant="warning"
                        onClick={alternarChat}
                    >
                        {mostrarOpciones ? (
                            <X size={32} />
                        ) : (
                            <img
                                src={AVATAR_URLS.launcher}
                                alt="Chat"
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        )}
                    </Button>
                </>
            )}
            {(estaAbierto || estaCerrando) && (
                <Card className={`chatbot-window shadow ${estaCerrando ? 'closing' : ''}`}>
                    <Card.Header className="d-flex justify-content-between align-items-center bg-warning text-dark">
                        <div className="d-flex align-items-center">
                            {(historial.length > 1 || modoAyuda) && (
                                <>
                                    <Button variant="link" className="text-dark p-0 me-2 text-decoration-none d-flex align-items-center" onClick={handleAtras}>
                                        <ChevronLeft size={20} />
                                    </Button>
                                    <div className="vr me-2" style={{ height: '20px', alignSelf: 'center' }}></div>
                                </>
                            )}
                            <div className="d-flex align-items-center">
                                <img
                                    src={AVATAR_URLS.profile}
                                    alt="Milo"
                                    className="rounded-circle me-2 border border-white"
                                    style={{ width: '35px', height: '35px', objectFit: 'cover' }}
                                />
                                <div>
                                    <h6 className="m-0 fw-bold">Milo</h6>
                                    <small className="text-dark" style={{ fontSize: '0.75rem', opacity: 0.9 }}>Asistente Ferremaster</small>
                                </div>
                            </div>
                        </div>
                        <Button variant="link" className="text-dark p-0" onClick={alternarChat}>
                            <X size={24} />
                        </Button>
                    </Card.Header>
                    <Card.Body className="chatbot-body">
                        {historial.map((item, indice) => (
                            <div key={indice} className={`chat-message ${indice === historial.length - 1 ? 'active' : 'history'}`}>
                                {item.type === 'bot' ? (
                                    <div className="d-flex align-items-end mb-3">
                                        <img
                                            src={AVATAR_URLS.profile}
                                            alt="Milo"
                                            className="rounded-circle me-2 mb-2 shadow-sm"
                                            style={{ width: '32px', height: '32px', objectFit: 'cover', minWidth: '32px' }}
                                        />
                                        <div style={{ maxWidth: '85%' }}>
                                            <div className="bot-message">
                                                {item.heroImage === 'welcome' && (
                                                    <div className="text-center mb-1">
                                                        <img
                                                            src={AVATAR_URLS.welcome}
                                                            alt="Milo celebrando"
                                                            className="img-fluid rounded"
                                                            style={{ maxHeight: '130px' }}
                                                        />
                                                    </div>
                                                )}
                                                <p className="mb-1">{renderizarMensaje(item.message)}</p>
                                                {item.timestamp && (
                                                    <small className="message-timestamp">
                                                        {formatearTimestamp(item.timestamp)}
                                                    </small>
                                                )}
                                            </div>
                                            {indice === historial.length - 1 && item.options && !modoAyuda && (
                                                <div className="options-list mt-2">
                                                    {item.options.map((opcion, idx) => (
                                                        <Button
                                                            key={idx}
                                                            variant="outline-secondary"
                                                            size="sm"
                                                            className="d-block w-100 mb-1 text-start text-dark"
                                                            onClick={() => handleClickOpcion(opcion)}
                                                        >
                                                            {opcion.label}
                                                        </Button>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="user-message mb-3">
                                        <p className="mb-1">{item.message}</p>
                                        {item.timestamp && (
                                            <small className="message-timestamp">
                                                {formatearTimestamp(item.timestamp)}
                                            </small>
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                        {botEscribiendo && (
                            <div className="chat-message active">
                                <div className="d-flex align-items-end mb-3">
                                    <img
                                        src={AVATAR_URLS.thinking}
                                        alt="Milo pensando"
                                        className="rounded-circle me-2 mb-2 shadow-sm"
                                        style={{ width: '32px', height: '32px', objectFit: 'cover', minWidth: '32px' }}
                                    />
                                    <div className="bot-message typing-indicator">
                                        <div className="typing-dots">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div ref={refFinMensajes} />
                    </Card.Body>
                    <Card.Footer className="bg-light p-1">
                        {modoAyuda ? (
                            <Form onSubmit={handleEntradaUsuario}>
                                {pasoData === 'mensaje' && (
                                    <div className="mb-2">
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                            <Form.Control
                                                ref={refArchivo}
                                                type="file"
                                                onChange={handleSeleccionarArchivo}
                                                className="d-none"
                                                id="archivo-adjunto"
                                                accept="*/*"
                                            />
                                            <Button
                                                variant="outline-secondary"
                                                size="sm"
                                                onClick={() => refArchivo.current?.click()}
                                                className="d-flex align-items-center gap-1"
                                            >
                                                <Paperclip size={16} />
                                                <span>Adjuntar archivo</span>
                                            </Button>
                                        </div>
                                        {nombreArchivo && (
                                            <div className="chatbot-file-attachment">
                                                <span className="file-name" title={nombreArchivo}>
                                                    📎 {nombreArchivo}
                                                </span>
                                                <Button
                                                    variant="link"
                                                    size="sm"
                                                    className="btn-remove-file text-danger p-0"
                                                    onClick={handleEliminarArchivo}
                                                    title="Eliminar archivo"
                                                >
                                                    <X size={14} />
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                )}
                                <InputGroup>
                                    <Form.Control
                                        ref={refInput}
                                        type="text"
                                        placeholder={
                                            pasoData === 'nombre' ? 'Escribe tu nombre...' :
                                                pasoData === 'email' ? 'Escribe tu email...' :
                                                    pasoData === 'telefono' ? 'Escribe tu teléfono...' :
                                                        'Escribe tu mensaje...'
                                        }
                                        value={mensajeUsuario}
                                        onChange={(e) => setMensajeUsuario(e.target.value)}
                                        className="border-0"
                                    />
                                    <Button
                                        variant="warning"
                                        type="submit"
                                        disabled={!mensajeUsuario.trim()}
                                    >
                                        <Send size={18} />
                                    </Button>
                                </InputGroup>
                            </Form>
                        ) : (
                            <InputGroup>
                                <Form.Control
                                    type="text"
                                    placeholder="Selecciona una opción"
                                    disabled
                                    className="border-0 placeholder-input"
                                />
                            </InputGroup>
                        )}
                    </Card.Footer>
                </Card>
            )}
        </div>
    );
};

export default Chatbot;